// extracted by mini-css-extract-plugin
module.exports = {"details_header":"AccountRightPanel_details_header__1Ju_N"};